import { type ErrorResponderItem, type RequestedResponder, type ResponderItem } from '../types';

export const mapErrorForResponder = (requestedResponders: Record<string, RequestedResponder>) =>
	Object.entries(requestedResponders).reduce(
		(acc, [key, value]) => {
			acc[key] = {
				id: value.id,
				type: value.type,
				isError: true,
				acknowledged: true,
				isLoading: false,
			};
			return acc;
		},
		{} as Record<string, ErrorResponderItem>,
	);

export const isNotLoaded = (responder?: ResponderItem) =>
	!Boolean(responder?.isError) && !Boolean(responder?.acknowledged);
